import * as React from "react"
import {Box, Grid, IconButton, Tooltip, Typography} from "@mui/material";
import {AppLink, useAppToast} from "@ui-seeker/app";
import {BasicTableSeeker, CardSeeker, IconSeeker, ImageSeeker} from "@ui-seeker/core"

import {imageModalData} from "@signals";
import {useProxiedImage} from "../../../@hooks";
import {rawMatcherImageSizeValue} from "../../@signals";


export default function RawMatcherTargetProduct({ data={} }) {
    // Build full product name from parts
    const productName = [data.superTitle, data.productTitle, data.subtitle, data.variant].filter(Boolean).join(' ')
    const { decodedURL: __thumbnail, imageResourceURL } = useProxiedImage(data.thumbnail)
    const { showToast } = useAppToast()

    // The operators collect the URLs of the products whose SKU does not exist yet into an Excel,
    // so the link is copied verbatim: it is what the scraper captured and what the retailer resolves
    const copyProductUrl = async () => {
        try {
            await navigator.clipboard.writeText(data.productUrl)
            showToast.success("Product link copied")
        } catch (e) {
            showToast.error("Could not copy the link")
        }
    }

    return <CardSeeker elevation={3} sx={{ width: 1, height: 0.8, overflowY: 'auto' }}>
        <Grid container spacing={2}>
            <Grid item xs={3} display="flex" justifyContent="center" alignItems="center">
                <ImageSeeker
                    useSpinner
                    lazyLoad={false}
                    src={imageResourceURL}
                    sx={{ border: '1px solid', borderColor: 'divider', width: rawMatcherImageSizeValue.value, height: 'auto', cursor: 'pointer' }}
                    onClick={() => imageModalData.value = {
                        title: productName,
                        fullSRC: __thumbnail
                    }}
                />
            </Grid>

            <Grid item xs={9} display="flex" flexDirection="column" alignItems="flex-end">
                {data.superTitle && <Typography color="text.disabled" fontSize="0.9rem">
                    {data.superTitle}
                </Typography>}
                {data.productUrl ? (
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <AppLink to={data.productUrl} target="_blank">
                            <Typography fontWeight="bold" display="flex" alignItems="center" gap={1}>
                                {data.productTitle}
                                <IconSeeker icon="external-link" sx={{ color: 'text.disabled', fontSize: "0.85rem" }} />
                            </Typography>
                        </AppLink>
                        <Tooltip title="Copy product link">
                            <IconButton size="small" onClick={copyProductUrl} aria-label="Copy product link">
                                <IconSeeker icon="copy" sx={{ color: 'text.disabled', fontSize: "0.85rem" }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                ) : (
                    <Typography fontWeight="bold">
                        {data.productTitle}
                    </Typography>
                )}
                {data.subtitle && <Typography color="text.disabled" fontSize="0.9rem">
                    {data.subtitle}
                </Typography>}
                {data.variant && <Typography color="primary.main" fontSize="1rem" fontWeight="bold">
                    Variant: {data.variant}
                </Typography>}
                <Typography color="text.disabled" mt={1}>
                    Brand: {data.brand || "-"}
                </Typography>
                <Typography color="text.disabled">
                    Retailer: {data.retailer || "-"}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <BasicTableSeeker
                    data={[data]}
                    headers={[[
                        {label: 'Product ID'},
                        {label: 'Site ID'},
                        {label: 'Country'}
                    ]]}
                    columns={[
                        { name: 'productID', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'siteID', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'country', render: value => <Box textAlign="center">{value || "-"}</Box> }
                    ]}
                    cardProps={{ sx: { boxShadow: 0 } }}
                />
            </Grid>
        </Grid>
    </CardSeeker>
}